import { lazyNamed } from 'src/utils/lazyNamed.ts';

export const Placements = {
  List: lazyNamed(() => import('./containers/PlacementsList/index.tsx'), 'PlacementsList'),
  Form: lazyNamed(() => import('./containers/PlacementForm/index.tsx'), 'PlacementForm'),
  PlacementHistory: lazyNamed(() => import('./containers/PlacementHistory.tsx'), 'PlacementHistory'),
};
